import { Navigate, Outlet, useParams } from "react-router-dom";

import GtmLeadsSubnav from "./components/GtmLeadsSubnav";
import { useGtmLeadsFlag } from "./hooks/useGtmLeadsFlag";

/**
 * GTM → Leads layout shell (story 11.2). Child routes render via Outlet.
 * Content studio stays on `/ai-content`. Flag off → redirect to Content studio.
 */
export default function GtmLeadsApp() {
  const gtmLeadsEnabled = useGtmLeadsFlag();
  const { projectId } = useParams<{ projectId: string }>();

  if (!gtmLeadsEnabled) {
    return (
      <Navigate
        to={`/workspaces/${projectId}/ai-content?key=Content%20studio`}
        replace
      />
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col bg-white">
      <div className="border-b border-gray-100 px-4 py-2">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">GTM</p>
        <h2 className="text-base font-semibold text-gray-900">Leads</h2>
      </div>
      <GtmLeadsSubnav />
      <div className="min-h-0 flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
}
